import {
  FETCH_ACTIVITY_LOGS_REQUEST,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_ACTIVITY_LOGS_FAILURE,
} from "../action/types";

const initialState = {
  data: [],
  total: 0,
  isLoading: false,
  error: null,
};

const activityLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LOGS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    case FETCH_ACTIVITY_LOGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default activityLogsReducer;
